import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SensorEvent } from 'src/app/models/sensorEvent';
import { LocationGridMapping } from 'src/app/models/locationGridMapping';
import { TenantSessionState } from 'src/app/store/state/tenant-session.state';
import { buildSensorGrid, SensorTile } from '../../sensor-display';

@Component({
  selector: 'sc-sensor-grid',
  templateUrl: './sc-sensor-grid.component.html',
  styleUrls: ['./sc-sensor-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ScSensorGridComponent implements OnChanges {
  @Input() sensors: SensorEvent[] = [];
  @Input() emptyLocations: string[] = [];
  @Input() selectedSensorId: string | null = null;
  @Input() hoveredSensorId: string | null = null;
  @Input() showSteeringWheel = false;
  @Input() assetType: string | null = null;
  @Output() sensorSelect = new EventEmitter<SensorEvent>();
  @Output() sensorHover = new EventEmitter<string | null>();

  @SelectSnapshot(TenantSessionState.getLocationGridMapping) private locationGridMapping: LocationGridMapping;

  tiles: SensorTile[] = [];
  rowTemplate = '';
  colTemplate = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sensors || changes.emptyLocations) {
      const layout = buildSensorGrid(this.sensors, this.locationGridMapping?.mapping ?? [], this.emptyLocations);
      this.tiles = layout.tiles;
      this.rowTemplate = layout.rowTemplate;
      this.colTemplate = layout.colTemplate;
    }
  }

  trackTile = (_: number, t: SensorTile) => `${t.location}:${t.sensor?.sensorId ?? ''}`;

  onSelect(tile: SensorTile): void {
    if (tile.sensor) {
      this.sensorSelect.emit(tile.sensor);
    }
  }
}
